import Web3 from "web3";
const { sha3_256 } = require("js-sha3");

/** Display name for SHA3-256 (NIST) - default algorithm for stamping. */
export const HASH_ALGORITHM_SHA3_256 = "SHA3-256";

/** Display name for Keccak-256 (Ethereum-style) - supported for app-compat. */
export const HASH_ALGORITHM_KECCAK_256 = "Keccak-256";

/** URL for online SHA3-256 hash calculator (matches HASH_ALGORITHM_SHA3_256). */
export const HASH_CALCULATOR_URL_SHA3_256 =
  "https://emn178.github.io/online-tools/sha3_256.html";

/** URL for online Keccak-256 hash calculator (matches HASH_ALGORITHM_KECCAK_256). */
export const HASH_CALCULATOR_URL_KECCAK_256 =
  "https://emn178.github.io/online-tools/keccak_256.html";

/**
 * Calculates the content hash of a string (algorithm: see HASH_ALGORITHM_SHA3_256).
 * @param {string} data - The input string.
 * @returns {string} The hash as a hex string prefixed with '0x'.
 */
export function sha3_256_hash_string(data) {
  const encoder = new TextEncoder();
  const byteArray = encoder.encode(data); // Convert string to bytes (Uint8Array)
  const hash = sha3_256.update(byteArray).hex(); // Compute the hash
  return "0x" + hash; // Add '0x' prefix
}

/**
 * Calculates the content hash of a byte array (algorithm: see HASH_ALGORITHM_SHA3_256).
 * @param {Uint8Array} byteArray - The input byte array.
 * @returns {string} The hash as a hex string prefixed with '0x'.
 */
export function sha3_256_hash_bytes(byteArray) {
  const hash = sha3_256.update(byteArray).hex(); // Compute the hash
  return "0x" + hash; // Add '0x' prefix
}

/**
 * Calculates a keccak256 hash of a byte array.
 * @param {Uint8Array} byteArray - The input byte array.
 * @returns {string} The hash as a hex string prefixed with '0x'.
 */
export function keccak256_hash_bytes(byteArray) {
  const hexStringArray = byteArray.reduce((acc, byte) => {
    return acc + ("00" + byte.toString(16)).slice(-2);
  }, "");

  const web3 = new Web3();
  const hash = web3.utils.soliditySha3({
    type: "bytes",
    value: hexStringArray,
  });
  return hash;
}

/**
 * Calculates a keccak256 hash of a string.
 * @param {string} data - The input string.
 * @returns {string} The hash as a hex string prefixed with '0x'.
 */
export function keccak256_hash_string(data) {
  const byteArray = new TextEncoder().encode(data);
  return keccak256_hash_bytes(byteArray);
}
